if (!customElements.get('tab-container')) {
    customElements.define('tab-container', class TabContainer extends HTMLElement {
        constructor() {
            super();
            this.tabList = this.querySelector('[role="tablist"]');
            this.tabButtons = this.querySelectorAll('button[role="tab"]');
            this.tabPanels = this.querySelectorAll('[role="tabpanel"]');
            this.tabFocus = 0;

            let reviewBadgeElement = document.querySelector('.jdgm-preview-badge');
            if (reviewBadgeElement != null){
                reviewBadgeElement.addEventListener('click', this.openReviewsTab.bind(this));
            }

            this.tabButtons.forEach(button => {
                button.addEventListener('click', e => {
                    e.preventDefault();
                    let tabId = parseInt(button.getAttribute('aria-controls').replace('panel-', ''));
                    this.selectedTab = tabId;
                })
            })

            this.selectedTab = 0;

            this.tabList.addEventListener('keydown', this.onKeydown.bind(this));
        }
        set selectedTab(id){
            let tabLength = this.tabButtons.length - 1;
            let newId = id > tabLength ? 0 : Math.max(0, id);
            this.tabButtons.forEach(button => {
                button.setAttribute('aria-selected', false);
                button.classList.remove('active');
                button.tabIndex = -1;
                if (button.getAttribute('aria-controls') === `panel-${newId}`){
                    button.setAttribute('aria-selected', true);
                    button.classList.add('active');
                    button.tabIndex = 0;
                }
            })
            this.tabPanels.forEach(panel => {
                panel.classList.add('hidden');
                panel.tabIndex = -1;
                if (panel.getAttribute('id') === `panel-${newId}`){
                    panel.classList.remove('hidden');
                    panel.tabIndex = 0;
                }
            })

            this.activeTab = newId;
        }
        get selectedTab(){
            return this.activeTab;
        }       
        openReviewsTab(e){
            let reviewsButton = this.tabButtons.find(button => button.dataset.type === 'reviews');
            console.log(reviewsButton)
            if (reviewsButton){
                console.log(reviewsButton)
                let tabId = parseInt(reviewsButton.getAttribute('aria-controls').replace('panel-', ''));
                this.selectedTab = tabId;
            }
        }
        onKeydown(event) {
            let flag = false;
            switch (event.key) {
                case 'ArrowLeft':
                        this.selectedTab = this.selectedTab - 1;
                        flag = true;
                    break;
            
                    case 'ArrowRight':
                        this.selectedTab = this.selectedTab + 1;
                        flag = true;
                    break;
            
                    case 'Home':
                        this.selectedTab = 0;
                        flag = true;
                    break;
            
                    case 'End':
                        this.selectedTab = this.tabButtons.length;
                        flag = true;
                    break;
            
                    default:
                    break;
                }
            
            if (flag) {
                event.stopPropagation();
                event.preventDefault();
            }
            this.tabButtons[this.selectedTab].focus();
        }
    })
}